var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "section",
    [
      _c("b-loading", {
        attrs: { "can-cancel": true },
        model: {
          value: _vm.isLoading,
          callback: function ($$v) {
            _vm.isLoading = $$v
          },
          expression: "isLoading",
        },
      }),
      _c(
        "div",
        { staticClass: "modal-card", style: { minHeight: 40 + "vh" } },
        [
          _c("header", { staticClass: "modal-card-head" }, [
            _c("p", { staticClass: "modal-card-title" }, [
              _vm._v(" Manage email templates "),
            ]),
            _c("button", {
              staticClass: "delete",
              attrs: { type: "button" },
              on: {
                click: function ($event) {
                  return _vm.$emit("on-close")
                },
              },
            }),
          ]),
          _c("section", { staticClass: "modal-card-body" }, [
            !_vm.addNewActive && !_vm.editActive
              ? _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c(
                      "b-button",
                      {
                        attrs: { "icon-left": "plus", type: "is-primary" },
                        on: {
                          click: function ($event) {
                            _vm.addNewActive = true
                          },
                        },
                      },
                      [_vm._v(" New template ")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            !_vm.addNewActive && !_vm.editActive
              ? _c(
                  "div",
                  { staticClass: "block" },
                  [
                    _c(
                      "b-field",
                      { attrs: { label: "Template language" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { placeholder: "select a language" },
                            model: {
                              value: _vm.selectedLang,
                              callback: function ($$v) {
                                _vm.selectedLang = $$v
                              },
                              expression: "selectedLang",
                            },
                          },
                          _vm._l(_vm.languages, function (lang) {
                            return _c(
                              "option",
                              { key: lang, domProps: { value: lang } },
                              [_vm._v(" " + _vm._s(lang) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                    _c(
                      "b-field",
                      { attrs: { label: "Model" } },
                      [
                        _c(
                          "b-select",
                          {
                            attrs: { placeholder: "Select a modal" },
                            model: {
                              value: _vm.selectedTemplate,
                              callback: function ($$v) {
                                _vm.selectedTemplate = $$v
                              },
                              expression: "selectedTemplate",
                            },
                          },
                          _vm._l(_vm.mailTemplates, function (template) {
                            return _c(
                              "option",
                              {
                                key: template.id,
                                domProps: { value: template },
                              },
                              [_vm._v(" " + _vm._s(template.name) + " ")]
                            )
                          }),
                          0
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm.addNewActive
              ? _c(
                  "div",
                  [
                    _c("templateForm", {
                      attrs: {
                        template: _vm.newTemplate,
                        langs: _vm.languages,
                      },
                      on: { "on-close": _vm.closeModal },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm.editActive
              ? _c(
                  "div",
                  [
                    _c("templateForm", {
                      attrs: {
                        template: _vm.selectedTemplate,
                        langs: _vm.languages,
                      },
                      on: { "on-close": _vm.closeModal },
                    }),
                  ],
                  1
                )
              : _vm._e(),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }